import { cn } from '@tripleten/cn';

export const cnHeader = cn('header');
